import React from "react";
import { useDispatch } from "react-redux";
import { push } from "redux-first-history";

import logo from "../../assets/images/logo-trucoxo.png";
import victoryImg from "../../assets/images/game-victory.png";
import defeatImg from "../../assets/images/game-defeat.png";

import "./GameOutcomeModal.scss";

const GameOutcomeModal = ({ outcome }) => {
  const dispatch = useDispatch();

  if (!outcome) return null;

  const isVictory = outcome === "victory";
  const handleClose = () => dispatch(push("/"));

  return (
    <div className="game-outcome" role="dialog" aria-modal="true">
      <header className="game-outcome__header">
        <img
          src={logo}
          alt="Truco XP"
          className="game-outcome__logo"
          draggable={false}
        />
        <button
          type="button"
          className="game-outcome__close"
          onClick={handleClose}
          aria-label="Fechar"
        >
          <i className="fa-solid fa-xmark" />
          <span>Fechar</span>
        </button>
      </header>

      <main className="game-outcome__main">
        <div className="game-outcome__image">
          <img
            src={isVictory ? victoryImg : defeatImg}
            alt=""
            draggable={false}
          />
        </div>

        <div className="game-outcome__text">
          <h2
            className={`game-outcome__title ${
              isVictory
                ? "game-outcome__title--victory"
                : "game-outcome__title--defeat"
            }`}
          >
            {isVictory ? "Vitória!" : "Derrota!"}
          </h2>
          <p className="game-outcome__subtitle">
            {isVictory
              ? "Parabéns, você ganhou a partida!"
              : "Que pena, você sofreu uma derrota."}
          </p>
        </div>

        <button
          type="button"
          className="game-outcome__continue"
          onClick={handleClose}
        >
          Continuar
        </button>
      </main>

      <footer className="game-outcome__footer">
        <span>trucoxp© 2026</span>
        <span className="game-outcome__footer-sep">•</span>
        <a
          href="/termos-e-condicoes.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Termos de Uso
        </a>
        <span className="game-outcome__footer-sep">|</span>
        <a
          href="/politica-de-privacidade.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de Privacidade
        </a>
      </footer>
    </div>
  );
};

export default GameOutcomeModal;
